<template>
  <div class="admin-sites">
    <div class="panelheader border-1">
      <div class="title">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/admin/clients'}">Clients Admin</el-breadcrumb-item>        
          <el-breadcrumb-item :to="{ path: '/admin/clients/' + clientId}">{{pageName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="btn-wrapper">
        <el-button type="add" @click="onNewSite">New Site</el-button>  
      </div>

    </div>
    
    <div class="sites">
        <h2>{{clientName}}</h2>

        <div v-if="newSite">
          <newsite :clientId="clientId" @close="onClose"></newsite>
        </div>
        <div v-else-if="editSite">
          <editsite :siteData="siteData" @close="onClose"></editsite>
        </div>
        <div v-else>
          <sitetable v-if='!reloading'
            :id="clientId"
            @editSite="onEditSite" 
            @deleteSite="onDeleteSite">
          </sitetable>
        </div>
    </div>
  </div>
</template>

<script>
  import auth from '../../../auth'
  import requests from '../../../requests';

  import newSite from './NewSite.vue';
  import editSite from './EditSite.vue';
  import siteTable from './SiteTable.vue';
  
  export default {
    name: 'admin-sites',
    data () {
      return {
        pageName: 'Sites Admin',
        clientId: 0,
        clientName: '',
        newSite: false,
        editSite: false,
        userIsSuperAdmin: false,
        reloading: false
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      this.userIsSuperAdmin = (profile.role === 3);
      
      this.clientId = this.$route.params.id;

      var context = this;
      requests.getClient(this, context.clientId, function(result){
        context.clientName = result.data.name;
      })

    },
    updated() {
      this.reloading = false;
    },
    methods: {
      onNewSite() {
        this.editSite = false;
        this.newSite = true;
      },
      onEditSite(siteData) {
        console.log(siteData);
        this.siteData = siteData;

        this.newSite = false;
        this.editSite = true;
      },
      onDeleteSite(id) {
        console.log(id);
        var context = this;
        requests.deleteSite(this, id, function(result) {
          if(result.action !== 'success') {
            console.log(result);
            context.$message({
              type: 'error',
              message: 'Couldn\'t delete site: ' + result.msg.body.msg,
            })
          }
          context.reloading = true;
        });
      },
      onClose() {
        this.newSite = false;
        this.editSite = false;
      },
    },
    components: {
      'newsite': newSite,
      'editsite': editSite,
      'sitetable': siteTable
    }
  }
</script>

<style>
  .admin-sites .sites {
    display: block;
    padding: 15pt;
    background-color: white;
  }


</style>



// WEBPACK FOOTER //
// Sites.vue?564c30f0